import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Grid, Label, List, Image } from 'semantic-ui-react';
import { FileUploadInterface } from '../../models/Profile';
import { useStore } from '../../stores/store';
import { userLanguage } from '../userLanguageSchema/userLanguage';
import UploadModal from './UploadModal';
import { FilesFolderType } from '../../api/types';

function Digital() {
  const {
    activityStore: { selectedActivity: activity, downloadFilesStore },
    commonStore,
    userStore,
    dashboardStore: {
      dashboard: { localFilesForItem },
      getLocalFilesBasedOnItem,
    },
    viewStore: { itemFiles },
  } = useStore();

  // const ref = useRef<any>(null);
  // const mouse: any = useMouse(ref);
  const [showFiles, setShowFiles] = useState<string>('');
  const [showFolders, setShowFolders] = useState<boolean>(false);

  useEffect(() => {
    if(commonStore.devEnv && (commonStore.hfcCustomerChanges ||userStore.user?.customerName==="TNCA")){
      commonStore.devEnv = false
    }
    if (commonStore.devEnv && !commonStore.hfcCustomerChanges ) {
      getLocalFilesBasedOnItem(activity?.id);
    }
    // eslint-disable-next-line
  }, [activity?.id, commonStore.devEnv]);

  // useEffect(() => {
  //   const collectData: any = [];
  //   sortedListItems?.tasks?.forEach((taskData: any) => {
  //     taskData?.subTasks.forEach((subTask: any) => {
  //       if (isPdfGenerated?.subTaskId === subTask?.subTaskId) {
  //         subTask?.files?.push(isPdfGenerated.files[0]);
  //       }
  //       if (subTask?.files?.length > 0) {
  //         collectData?.push(taskData);
  //       }
  //     });
  //   });
  //   setCollectFileSubTask(collectData);
  //   // eslint-disable-next-line
  // }, [isPdfGenerated]);

  const downloadData = async (url: string, fileName: string) => {
    const fileExec = url?.split('.')?.pop();
    await downloadFilesStore(url, fileName + '.' + fileExec);
  };

  const getExtension = (url: string) => {
    return url?.split(/[#?]/)?.[0]?.split('.')?.pop()?.trim();
  };

  // const showButton = () => {
  //   setShowVideoMenu(!showVideoMenu);
  //   mediaAssetStore?.setScreenPositionMicroTagging(mouse?.x, mouse?.y);
  // };

  const showExecIcon = (url: string) => {
    const extension = getExtension(url) || '';
    if (extension === 'pdf') {
      return <List.Icon name="file pdf outline" color="blue" />;
    } else if (['doc', 'docx'].includes(extension)) {
      return <List.Icon name="file alternate outline" color="blue" />;
    } else if (
      ['gif', 'jpg', 'jpeg', 'tiff', 'png', 'webp', 'bmp'].includes(extension)
    ) {
      return <List.Icon name="file image outline" color="blue" />;
    } else if (['mp3', 'mp4'].includes(extension)) {
      return <List.Icon name="file audio outline" color="blue" />;
    } else {
      return <List.Icon name="file outline" color="blue" />;
    }
  };

  const downloadLocalFile = async (url: string, fileName: string) => {
    const splitPath: string[] = url.split('build') || [];
    const link = document.createElement('a');
    link.href = splitPath[1];
    link.setAttribute('download', fileName);
    link.setAttribute('target', 'blank');

    // Append to html link element page
    document.body.appendChild(link);

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode?.removeChild(link);
  };

  const openFolder = (folderName: string) => {
    if (folderName !== showFiles) {
      setShowFiles(folderName);
    } else {
      setShowFiles('');
    }
  };

  return (
    <div className="digital-container">
      <div>
        {commonStore.filterModeTwo?.includes('AVLAVT06') ? (
          <></>
        ) : (
          <Label
            corner="right"
            className={
              commonStore.filterModeZero?.includes('AVLAVT06')
                ? 'component-isDisabled'
                : ''
            }
          >
            <UploadModal />
          </Label>
        )}
        {!commonStore.devEnv ? (
          <>
            {itemFiles.length === 0 ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {/* <p>-- No Files --</p> */}
                <Image
                  src={'/assets/empty.svg'}
                  alt={'empty'}
                  width="300px"
                  height="300px"
                />
              </div>
            ) : (
              <List
                style={{ marginBottom: 0, cursor: 'pointer' }}
                onClick={() => setShowFolders(!showFolders)}
              >
                <List.Icon
                  color="blue"
                  style={{ marginLeft: '10px' }}
                  name={
                    itemFiles?.length === 0
                      ? 'folder'
                      : showFolders
                        ? 'folder open'
                        : 'folder'
                  }

                  //Files
                />
                {
                  (
                    userLanguage[0]
                      .AssetsViewItemLevelViewPageAssetsSegmentDigitalTab
                      .AVILVPASDTPL01 as any
                  )?.[`${commonStore.language.key}`]
                }
              </List>
            )}

            {showFolders &&
              itemFiles?.map((folder: FilesFolderType, index: number) => {
                return (
                  <>
                    <Grid.Column
                      style={{ marginLeft: '30px', cursor: 'pointer' }}
                      key={index}
                      onClick={() => openFolder(folder.folderName)}
                    >
                      <List.Icon
                        name={
                          showFiles !== '' && folder.folderName === showFiles
                            ? 'folder open'
                            : 'folder'
                        }
                        color="blue"
                      />
                      {folder.folderName}
                      {showFiles !== '' && folder.folderName === showFiles && (
                        <Grid.Column style={{ marginLeft: '20px' }}>
                          {folder?.files.map((file: FileUploadInterface) => (
                            <div>
                              {showExecIcon(file.url)}
                              <span
                                onClick={() =>
                                  downloadData(file.url, file.fileName)
                                }
                              >
                                {file.fileName + '.' + getExtension(file.url)}{' '}
                              </span>
                            </div>
                          ))}
                        </Grid.Column>
                      )}
                    </Grid.Column>
                  </>
                );
              })}
          </>
        ) : (
          <>
            {localFilesForItem?.length === 0 ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {/* <p>-- No Files --</p> */}
                <Image
                  src={'/assets/empty.svg'}
                  alt={'empty'}
                  width="300px"
                  height="300px"
                />
              </div>
            ) : (
              <List style={{ marginBottom: 0 }}>
                <List.Icon
                  color="blue"
                  name={
                    localFilesForItem?.length === 0
                      ? 'folder'
                      : showFolders
                        ? 'folder open'
                        : 'folder'
                  }
                  onClick={() => setShowFolders(!showFolders)}
                  //Files
                />
                {
                  (
                    userLanguage[0]
                      .AssetsViewItemLevelViewPageAssetsSegmentDigitalTab
                      .AVILVPASDTPL01 as any
                  )?.[`${commonStore.language.key}`]
                }
              </List>
            )}
            {showFolders &&
              localFilesForItem?.map(
                (
                  localFile: {
                    files: {
                      id: string;
                      fileName: string;
                      path: string;
                      createdAt: string;
                    }[];
                    folderName: string;
                  },
                  index: number,
                ) => {
                  return (
                    <>
                      <Grid.Column
                        style={{ marginLeft: '30px', cursor: 'pointer' }}
                        key={index}
                        onClick={() => openFolder(localFile.folderName)}
                      >
                        <List.Icon
                          name={
                            showFiles !== '' &&
                            localFile.folderName === showFiles
                              ? 'folder open'
                              : 'folder'
                          }
                          color="blue"
                        />
                        {localFile.folderName}
                        {showFiles !== '' &&
                          localFile.folderName === showFiles && (
                            <Grid.Column style={{ marginLeft: '20px' }}>
                              {localFile?.files.map(
                                (file: {
                                  id: string;
                                  fileName: string;
                                  path: string;
                                  createdAt: string;
                                }) => {
                                  const url = file.path.replace(/\\\\/g, '\\');
                                  const filename = url.substring(
                                    url.lastIndexOf('\\') + 1,
                                  );
                                  return (
                                    <div>
                                      {showExecIcon(file.path)}
                                      <span
                                        onClick={() =>
                                          downloadLocalFile(url, filename)
                                        }
                                      >
                                        {file.fileName}
                                      </span>
                                    </div>
                                  );
                                },
                              )}
                            </Grid.Column>
                          )}
                      </Grid.Column>
                    </>
                  );
                  // const url = localFile.path.replace(/\\\\/g, '\\');
                  // const filename = url.substring(url.lastIndexOf('\\') + 1);
                  // return (
                  //   <div
                  //     style={{
                  //       display: 'flex',
                  //       marginLeft: '12px',
                  //     }}
                  //     key={localFile?.id}
                  //   >
                  //     <span
                  //       className="fileStructure"
                  //       onClick={() => downloadLocalFile(url, filename)}
                  //     >
                  //       {filename}
                  //     </span>
                  //   </div>
                  // );
                },
              )}
          </>
        )}
      </div>
    </div>
  );
}

export default observer(Digital);
